// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {SeqId} from './seq-id.js'

export class TextSelection {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): TextSelection {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsTextSelection(bb: flatbuffers.ByteBuffer, obj?: TextSelection): TextSelection {
    return (obj || new TextSelection()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsTextSelection(bb: flatbuffers.ByteBuffer, obj?: TextSelection): TextSelection {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new TextSelection()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  anchor(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  focus(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startTextSelection(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addAnchor(builder: flatbuffers.Builder, anchorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, anchorOffset, 0)
  }

  static addFocus(builder: flatbuffers.Builder, focusOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, focusOffset, 0)
  }

  static endTextSelection(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
